import React, { Fragment } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { useMediaQuery } from 'react-responsive'

const CarouselSettingsMobile = {
    showStatus: true,
    showThumbs: false,
    showArrows: true,
    showIndicators: false,
    infiniteLoop: true,
    selectedItem: 0,
    centerMode: true,
    centerSlidePercentage: 100,
    emulateTouch: true,
    dynamicHeight: true
}

const CarouselSettingsDesktop = {
  showStatus: true,
  showThumbs: false,
  showArrows: true,
  showIndicators: false,
  infiniteLoop: true,
  selectedItem: 0,
  centerMode: true,
  centerSlidePercentage: 101,
  emulateTouch: true
}


const ProductImageSlider = ({ values }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  const CarouselSettings = isMobile ? CarouselSettingsMobile : CarouselSettingsDesktop;

  return (  
      <Carousel {...CarouselSettings}
          preventMovementUntilSwipeScrollTolerance={true} 
          swipeScrollTolerance={100}
      renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && 
            <button type="button" onClick={onClickHandler} title={label} className={"carousel-arrow carousel-arrow--product carousel-arrow--prev"} />
      }
      renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && 
            <button type="button" onClick={onClickHandler} title={label} className={"carousel-arrow carousel-arrow--product carousel-arrow--next"} />
      }
      statusFormatter={(current, total) => {
        const formattedCurrent = current >= 10 ? current : `0${current}`
        const formattedTotal = total >= 10 ? total : `0${total}`
        return (
          <span className="carousel-status-inner carousel-status-inner--product">
            <span className='carousel-status-inner__current'>{ formattedCurrent }</span>
            <span className='carousel-status-inner__separator'>/</span>
            <span className='carousel-status-inner__total'>{ formattedTotal }</span>
          </span>
        )
      }}>
      {
        values.map((value, index) =>
          <div className="product-detail__image-container" key={`figure${index}`} data-aos="fade" data-aos-offset="300" data-aos-easing="linear" data-aos-duration="400">
              <img className="product-detail__image product-detail__image--main" src={value.image} itemProp="image" alt={value.imagealt} loading="lazy" />
          </div>
        )
      }
    </Carousel>
  )
}

export default ProductImageSlider;

